import { Tooltip as BootstrapTooltip } from "bootstrap";
import { useEffect, useRef, useState } from "react";

const Tooltip: React.FC<{
  title: string;
  placement?: "auto" | "top" | "bottom" | "left" | "right";
  parentContainer: React.RefObject<HTMLDivElement>;
  children: any;
}> = ({ title, placement = "bottom", parentContainer, children }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);

  const [isNormalTooltipSet, setIsNormalTooltipSet] = useState<boolean>(false);
  const [isFullScreenTooltipSet, setIsFullScreenTooltipSet] =
    useState<boolean>(false);

  useEffect(() => {
    //console.log("tooltip-init-nodep");

    const onFullScreenChange = (event: any) => {
      if (event.target !== parentContainer.current) {
        // console.log("tooltip-onfullscreenchange-different-container()");
        return;
      }

      if (document.fullscreenElement) {
        setIsFullScreen(true);
      } else {
        setIsFullScreen(false);
      }

      //console.log("tooltip-onfullscreenchange()", event, container);
    };

    document.addEventListener("fullscreenchange", onFullScreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", onFullScreenChange);
    };
  }, [parentContainer]);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    if (!isFullScreen) {
      if (!isNormalTooltipSet) {
        setIsNormalTooltipSet(true);

        // console.log("create-tooltip-normal");

        new BootstrapTooltip(containerRef.current, {
          trigger: "hover",
          placement: placement,
          container: "body",
          title: title,
        });
      }
    } else {
      if (!isFullScreenTooltipSet) {
        setIsFullScreenTooltipSet(true);

        if (document.fullscreenElement) {
          // console.log("create-tooltip-full-screen");

          new BootstrapTooltip(containerRef.current, {
            trigger: "hover",
            placement: placement,
            container: document.fullscreenElement,
            title: title,
          });
        }
      }
    }
  }, [
    title,
    placement,
    isFullScreen,
    isNormalTooltipSet,
    isFullScreenTooltipSet,
  ]);

  return (
    <div ref={containerRef} style={{ zIndex: 1 }}>
      {children}
    </div>
  );
};

export default Tooltip;
